import ContactForm from "../components/ContactForm";
import Hero from "../components/Hero";
import contactImg from "../assests/images/contact-bg.jpg";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaChevronDown,
  FaArrowRight,
  FaShieldAlt,
  FaHeadset,
  FaHotel,
} from "react-icons/fa";

import { Helmet } from "react-helmet-async";

export default function ContactUs() {
  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Visit Us",
      value: "Office 302, 3rd Flr. HDS Tower Cluster F, Jumeirah Lakes Towers Dubai",
      description: "Our travel team is based in Dubai.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Call Us",
      value: "+971 4 447 3839",
      description: "Speak directly with our support team.",
      link: "tel:+971 4 447 3839",
    },
    {
      icon: <FaEnvelope />,
      title: "Email Us",
      value: "info@southtravels.com",
      description: "Send us your questions anytime.",
      link: "mailto:info@southtravels.com",
    },
  ];

  const faqs = [
    {
      question: "How fast do you respond?",
      answer:
        "Our team usually responds to inquiries within 24 hours.",
    },
    {
      question: "Can I customize my tour?",
      answer:
        "Yes. We can help arrange customizable tours and travel services according to your requirements.",
    },
    {
      question: "Can you help me choose a hotel?",
      answer:
        "Absolutely. Our team can help you find suitable hotels based on your preferred location, budget and travel requirements.",
    },
    {
      question: "Do you provide travel assistance?",
      answer:
        "Yes. Our team can assist with hotel bookings and other travel-related inquiries.",
    },
  ];

  return (
    <>
      {/* =====================================================
                SEO
            ===================================================== */}

      <Helmet>
        <title>Contact Us | Beach Hotels Dubai</title>

        <meta
          name="description"
          content="Contact Beach Hotels Dubai for hotel bookings, travel assistance, affordable stay options, and customer support in Dubai."
        />

        <link
          rel="canonical"
          href="https://dubaihotelrates.com/contact-us"
        />

        <meta
          property="og:title"
          content="Contact Us | Beach Hotels Dubai"
        />

        <meta
          property="og:description"
          content="Contact Beach Hotels Dubai for hotel bookings, travel assistance, affordable stay options, and customer support in Dubai."
        />

        <meta
          property="og:url"
          content="https://dubaihotelrates.com/contact-us"
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Contact Us | Beach Hotels Dubai"
        />

        <meta
          name="twitter:description"
          content="Contact Beach Hotels Dubai for hotel bookings, travel assistance, affordable stay options, and customer support in Dubai."
        />

        <meta
          name="robots"
          content="index, follow"
        />
      </Helmet>


      <div className="min-h-screen overflow-hidden bg-[#F4F8FC] text-[#0F172A]">


        {/* =====================================================
                    HERO
                ===================================================== */}

        <section className="relative">

          <Hero
            variant="inner"
            title="Let's Talk About Your Next Stay"
            subtitle="Have a question about hotels, bookings or travel? Our team is ready to help."
            backgroundImage={contactImg}
          />

        </section>


        {/* =====================================================
                    CONTACT QUICK INFO
                ===================================================== */}

        <section className="relative z-20 -mt-10 px-4 sm:-mt-14 sm:px-6 lg:px-8">

          <div className="mx-auto max-w-7xl">

            <div className="overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-[0_20px_60px_rgba(15,23,42,0.10)]">

              <div className="grid grid-cols-1 md:grid-cols-3">

                {contactInfo.map((item, index) => {

                  const content = (
                    <div
                      className={`
                                                group
                                                relative
                                                h-full
                                                p-6
                                                transition-all
                                                duration-300
                                                hover:bg-[#F8FBFF]
                                                sm:p-7
                                                lg:p-8
                                                ${index !==
                          contactInfo.length - 1
                          ? "border-b border-slate-100 md:border-b-0 md:border-r"
                          : ""
                        }
                                            `}
                    >

                      <div className="flex items-start gap-4">

                        {/* Icon */}

                        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#EAF3FF] text-[#174EA6] transition-all duration-300 group-hover:bg-[#174EA6] group-hover:text-white group-hover:shadow-lg">

                          {item.icon}

                        </div>


                        {/* Text */}

                        <div className="min-w-0">

                          <p className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-[#174EA6]">
                            {item.title}
                          </p>

                          <h3 className="mt-1.5 break-words text-sm font-extrabold leading-5 text-[#0F172A] sm:text-base">
                            {item.value}
                          </h3>

                          <p className="mt-1.5 text-xs leading-5 text-slate-400">
                            {item.description}
                          </p>

                        </div>

                      </div>

                    </div>
                  );

                  return item.link ? (
                    <a
                      key={index}
                      href={item.link}
                    >
                      {content}
                    </a>
                  ) : (
                    <div key={index}>
                      {content}
                    </div>
                  );
                })}

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
                    CONTACT + FORM
                ===================================================== */}

        <section className="px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">

          <div className="mx-auto max-w-7xl">

            <div className="grid items-start gap-10 lg:grid-cols-12 lg:gap-14">


              {/* =================================================
                                LEFT CONTENT
                            ================================================= */}

              <div className="lg:col-span-4">

                <div className="lg:sticky lg:top-28">

                  {/* Eyebrow */}

                  <div className="inline-flex items-center gap-2 rounded-full bg-[#EAF3FF] px-4 py-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-[#174EA6]">

                    <span className="h-1.5 w-1.5 rounded-full bg-[#FFC928]" />

                    Get In Touch

                  </div>


                  {/* Heading */}

                  <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-[#0F172A] sm:text-4xl">

                    We're Here to Help You Plan Your

                    <span className="mt-1 block text-[#174EA6]">
                      Perfect Dubai Stay.
                    </span>

                  </h2>


                  {/* Description */}

                  <p className="mt-5 text-sm leading-7 text-slate-500 sm:text-base">
                    Whether you need help finding the
                    right hotel, have a booking question,
                    or simply want to know more about our
                    services, our team is ready to assist.
                  </p>


                  {/* =================================================
                                        SERVICE HIGHLIGHTS
                                    ================================================= */}

                  <div className="mt-8 space-y-3">

                    {/* Hotel */}

                    <div className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-4 shadow-[0_8px_25px_rgba(15,23,42,0.04)] transition hover:-translate-y-0.5 hover:shadow-lg">

                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#EAF3FF] text-[#174EA6] transition group-hover:bg-[#174EA6] group-hover:text-white">
                        <FaHotel />
                      </div>

                      <div>

                        <p className="text-xs font-extrabold text-[#0F172A]">
                          Hotel Booking Assistance
                        </p>

                        <p className="mt-1 text-[11px] text-slate-400">
                          Find stays that match your
                          needs and budget.
                        </p>

                      </div>

                    </div>


                    {/* Support */}

                    <div className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-4 shadow-[0_8px_25px_rgba(15,23,42,0.04)] transition hover:-translate-y-0.5 hover:shadow-lg">

                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#FFF8D8] text-[#B58A00] transition group-hover:bg-[#FFC928] group-hover:text-[#0F172A]">
                        <FaHeadset />
                      </div>

                      <div>

                        <p className="text-xs font-extrabold text-[#0F172A]">
                          Travel Support
                        </p>

                        <p className="mt-1 text-[11px] text-slate-400">
                          Get assistance whenever you
                          need it.
                        </p>

                      </div>

                    </div>


                    {/* Secure */}

                    <div className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-4 shadow-[0_8px_25px_rgba(15,23,42,0.04)] transition hover:-translate-y-0.5 hover:shadow-lg">

                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#EAF3FF] text-[#174EA6] transition group-hover:bg-[#174EA6] group-hover:text-white">
                        <FaShieldAlt />
                      </div>

                      <div>

                        <p className="text-xs font-extrabold text-[#0F172A]">
                          Secure & Trusted
                        </p>

                        <p className="mt-1 text-[11px] text-slate-400">
                          Your information stays
                          protected.
                        </p>

                      </div>

                    </div>

                  </div>


                  {/* =================================================
                                        OFFICE CARD
                                    ================================================= */}

                  <div className="relative mt-6 overflow-hidden rounded-3xl bg-[#002B45] p-6 text-white">

                    <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#174EA6]/40 blur-3xl" />

                    <div className="pointer-events-none absolute -bottom-16 -left-16 h-40 w-40 rounded-full bg-[#FFC928]/10 blur-3xl" />

                    <div className="relative z-10">

                      <div className="flex items-center gap-3">

                        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#174EA6]">
                          <FaMapMarkerAlt />
                        </div>

                        <div>
                          <p className="text-[10px] font-bold uppercase tracking-wider text-[#FFC928]">
                            Our Office
                          </p>

                          <p className="mt-0.5 text-sm font-bold">
                            Dubai, UAE
                          </p>
                        </div>

                      </div>

                      <p className="mt-4 text-xs leading-6 text-white/55">
                        Office 302, 3rd Flr. HDS Tower,
                        Cluster F, Jumeirah Lakes Towers,
                        Dubai.
                      </p>

                    </div>

                  </div>


                  {/* Response time */}

                  <div className="mt-4 flex items-center gap-3 px-1">

                    <FaClock className="text-sm text-[#174EA6]" />

                    <p className="text-xs text-slate-400">
                      We usually respond within{" "}
                      <span className="font-bold text-[#0F172A]">
                        24 hours
                      </span>
                      .
                    </p>

                  </div>

                </div>

              </div>


              {/* =================================================
                                CONTACT FORM
                            ================================================= */}

              <div className="lg:col-span-8">

                <ContactForm />

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
                    MAP SECTION
                ===================================================== */}

        <section className="px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24">

          <div className="mx-auto max-w-7xl">

            {/* Heading */}

            <div className="mb-8">

              <div className="inline-flex items-center gap-2 rounded-full bg-[#EAF3FF] px-4 py-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-[#174EA6]">

                <FaMapMarkerAlt />

                Find Us

              </div>

              <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#0F172A] sm:text-4xl">
                Our Location in Dubai
              </h2>

              <div className="mt-4 h-1 w-16 rounded-full bg-gradient-to-r from-[#174EA6] to-[#FFC928]" />

              <p className="mt-4 max-w-2xl text-sm leading-6 text-slate-500">
                Visit our Dubai office or use the map below to
                find directions to our location.
              </p>

            </div>


            {/* Map */}

            <div className="relative overflow-hidden rounded-[30px] border-4 border-white bg-white shadow-[0_20px_60px_rgba(15,23,42,0.10)] sm:rounded-[36px]">

              <iframe
                src="https://www.google.com/maps?q=Dubai&output=embed"
                className="h-[320px] w-full sm:h-[420px] lg:h-[480px]"
                loading="lazy"
                title="Beach Hotels Dubai Location"
              />


              {/* Floating location card */}

              <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto">

                <div className="flex items-center gap-3 rounded-2xl border border-white/60 bg-white/95 px-4 py-3 shadow-xl backdrop-blur-md">

                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#002B45] text-white">
                    <FaMapMarkerAlt />
                  </div>

                  <div>

                    <p className="text-xs font-extrabold text-[#0F172A]">
                      Jumeirah Lakes Towers
                    </p>

                    <p className="mt-0.5 text-[10px] text-slate-400">
                      Dubai, United Arab Emirates
                    </p>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
                    FAQ
                ===================================================== */}

        <section className="relative overflow-hidden bg-[#F3F8FF] px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">

          {/* =====================================================
        DECORATIVE BACKGROUND
    ===================================================== */}

          <div className="pointer-events-none absolute -right-40 -top-40 h-[420px] w-[420px] rounded-full bg-[#174EA6]/10 blur-3xl" />

          <div className="pointer-events-none absolute -bottom-40 -left-40 h-[420px] w-[420px] rounded-full bg-[#FFC928]/10 blur-3xl" />


          {/* =====================================================
        MAIN CONTAINER
    ===================================================== */}

          <div className="relative z-10 mx-auto max-w-7xl">

            <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-start">


              {/* =================================================
                LEFT INTRO PANEL
            ================================================= */}

              <div className="relative overflow-hidden rounded-[30px] bg-[#002B45] p-7 text-white shadow-[0_20px_60px_rgba(0,43,69,0.15)] sm:p-9 lg:sticky lg:top-24 lg:p-10">

                {/* Decorative circles */}

                <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-[#174EA6]/30 blur-2xl" />

                <div className="pointer-events-none absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-[#FFC928]/10 blur-2xl" />


                <div className="relative z-10">

                  {/* Small label */}

                  <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3.5 py-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-[#FFC928] backdrop-blur-sm">

                    <span className="h-1.5 w-1.5 rounded-full bg-[#FFC928]" />

                    FAQ

                  </div>


                  {/* Heading */}

                  <h2 className="!text-white mt-6 text-3xl font-extrabold leading-tight sm:text-4xl">

                    Questions You
                    <br />

                    <span className="text-[#FFC928]">
                      May Have
                    </span>

                  </h2>


                  <p className="mt-5 max-w-md text-sm leading-7 text-white/65">
                    Find quick answers to the questions our travelers
                    ask most often about hotel bookings, reservations,
                    payments and our travel services.
                  </p>


                  {/* Helpful message */}

                  <div className="mt-8 rounded-2xl border border-white/10 bg-white/[0.06] p-5">

                    <div className="flex items-start gap-4">

                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#FFC928] text-[#002B45]">

                        <FaChevronDown className="text-sm" />

                      </div>

                      <div>

                        <p className="text-sm font-bold text-white">
                          Still have questions?
                        </p>

                        <p className="mt-1 text-xs leading-5 text-white/50">
                          Our team is always happy to help you
                          plan your perfect Dubai stay.
                        </p>

                      </div>

                    </div>

                  </div>


                  {/* Decorative bottom line */}

                  <div className="mt-10 flex items-center gap-3">

                    <div className="h-[2px] w-12 rounded-full bg-[#FFC928]" />

                    <div className="h-[2px] w-5 rounded-full bg-[#174EA6]" />

                    <div className="h-[2px] w-2 rounded-full bg-white/30" />

                  </div>

                </div>

              </div>


              {/* =================================================
                RIGHT FAQ LIST
            ================================================= */}

              <div className="space-y-4">

                {faqs.map((faq, index) => (

                  <details
                    key={index}
                    className="
                            group
                            relative
                            overflow-hidden
                            rounded-[22px]
                            border
                            border-slate-200
                            bg-white
                            shadow-[0_8px_30px_rgba(15,23,42,0.04)]
                            transition-all
                            duration-300
                            hover:-translate-y-0.5
                            hover:border-[#174EA6]/20
                            hover:shadow-[0_15px_40px_rgba(15,23,42,0.07)]
                            open:border-[#174EA6]/20
                            open:shadow-[0_15px_45px_rgba(15,23,42,0.08)]
                        "
                  >

                    {/* Gold active accent */}

                    <div className="absolute bottom-0 left-0 top-0 w-1 origin-left scale-y-0 bg-[#FFC928] transition-transform duration-300 group-open:scale-y-100" />


                    {/* =================================================
                            QUESTION
                        ================================================= */}

                    <summary
                      className="
                                flex
                                cursor-pointer
                                list-none
                                items-center
                                gap-4
                                px-5
                                py-5
                                sm:px-6
                                sm:py-6
                            "
                    >

                      {/* Number */}

                      <span
                        className="
                                    flex
                                    h-10
                                    w-10
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-xl
                                    bg-[#F3F8FF]
                                    text-xs
                                    font-extrabold
                                    text-[#174EA6]
                                    transition-all
                                    duration-300
                                    group-open:bg-[#174EA6]
                                    group-open:text-white
                                "
                      >
                        {String(index + 1).padStart(2, "0")}
                      </span>


                      {/* Question */}

                      <span className="flex-1 pr-2 text-sm font-extrabold leading-6 text-[#0F172A] sm:text-[15px]">
                        {faq.question}
                      </span>


                      {/* Arrow */}

                      <span
                        className="
                                    flex
                                    h-9
                                    w-9
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-full
                                    border
                                    border-slate-200
                                    bg-white
                                    text-[#174EA6]
                                    transition-all
                                    duration-300
                                    group-open:rotate-180
                                    group-open:border-[#174EA6]
                                    group-open:bg-[#174EA6]
                                    group-open:text-white
                                "
                      >
                        <FaChevronDown className="text-[10px]" />
                      </span>

                    </summary>


                    {/* =================================================
                            ANSWER
                        ================================================= */}

                    <div className="px-5 pb-6 pl-[76px] sm:px-6 sm:pb-7 sm:pl-[82px]">

                      <div className="mb-4 h-px w-full bg-slate-100" />

                      <p className="max-w-2xl text-sm leading-7 text-slate-500">
                        {faq.answer}
                      </p>

                    </div>

                  </details>

                ))}

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
                    FINAL CTA
                ===================================================== */}

        <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">

          <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[32px] bg-[#002B45] px-6 py-12 sm:px-10 md:px-14 lg:py-16">

            {/* Decorative glow */}

            <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#174EA6]/30 blur-3xl" />

            <div className="pointer-events-none absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-[#FFC928]/10 blur-3xl" />


            {/* Top accent */}

            <div className="absolute left-0 right-0 top-0 h-1 bg-gradient-to-r from-[#174EA6] via-[#174EA6] to-[#FFC928]" />


            <div className="relative z-10 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">

              <div className="max-w-2xl">

                <p className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-[#FFC928]">
                  Your Dubai Stay Awaits
                </p>

                <h2 className="mt-3 text-3xl font-extrabold leading-tight !text-white sm:text-4xl">
                  Need Help Finding the{" "}
                  <span className="text-[#FFC928]">
                    Right Hotel?
                  </span>
                </h2>

                <p className="mt-4 text-sm leading-7 text-white/60 sm:text-base">
                  Our team is ready to help you find a
                  comfortable stay that matches your
                  destination, budget and travel plans.
                </p>

              </div>


              <a
                href="tel:+971 4 447 3839"
                className="group inline-flex w-full items-center justify-center gap-3 rounded-xl bg-[#FFC928] px-7 py-4 text-sm font-extrabold text-[#0F172A] shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#FFD84A] hover:shadow-xl sm:w-auto"
              >
                Talk to Our Team

                <FaArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />

              </a>

            </div>

          </div>

        </section>

      </div>
    </>
  );
}